import Vue from 'vue'
import moment from "moment";

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm')
    }
})
Vue.filter('formatDateOnly', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
    }
})
Vue.filter('formatTime', function (value) {
    if (value) {
        return moment(String(value), 'HH:mm:ss').format('HH:mm')
    }
})
Vue.filter('striphtml', function (value, charCount) {
    let div = document.createElement("div");
    div.innerHTML = value;
    let text = div.textContent || div.innerText || "";
    return text.substring(0, charCount);
});